import React, {useState} from 'react';
import styled from "styled-components";
import {SwitchBasic} from "../../switch/SwitchBasic";
import InputSingle from "../../input/InputSingle";
import {deleteFiled, updateFiled} from "../../../api/field/FieldService";
import {handleActiveToast} from "../../sonner/ToastBasic";
import draggable from "../../../resources/icon/draggable.png";
import FieldFormatDisplay from "./FieldFormatDisplay";


/**
 * &필드 &유저필드
 * */

export const DrawerTriger = styled.button`
  cursor: pointer;
  border: 1px solid #d0d0d0;
  line-height: 30px;
  padding: 0 15px;
  text-align: center;
  height: 30px;
  margin-right: 5px;
`;

function FieldUser({each, setFlag, dragHandleProps}) {
    const [modify, setModify] =useState(false);
    const [data, setData] =useState(each);
    const update =()=>{
        setModify(true)
    }
    async function save(){
        const response = await updateFiled(data);
        if (response.status===200) {
            setModify(false)
            setFlag(true);
            handleActiveToast({description:"",message:"수정되었습니다.", labelListener:()=>{}})
        }else if(response.response.status===401){
            handleActiveToast({description:"",message:"로그인 하세요.", labelListener:()=>{}})
        }else if(response.response.status===403){
            handleActiveToast({description:"",message:"권한이 없습니다.", labelListener:()=>{}})
        }
    }



    async function deleteItem(){
        if(window.confirm("삭제 하시겠습니까")) {
            const response = await deleteFiled(data.id);
            if (response.status === 200) {
                setModify(false)
                setFlag(true);
                handleActiveToast({
                    description: "", message: "삭제 되었습니다.", labelListener: () => {
                    }
                })
            } else if (response.response.status === 401) {
                handleActiveToast({
                    description: "", message: "로그인 하세요.", labelListener: () => {
                    }
                })
            } else if (response.response.status === 403) {
                handleActiveToast({
                    description: "", message: "권한이 없습니다.", labelListener: () => {
                    }
                })
            }
        }
    }

    return (
        <>
            <th className="fieldset-th relative">
                {modify ? (
                    <InputSingle target={'title'}  data={{ data: data, setData: setData }} required={true} className={'field-add'}/>
                ):(<span className={"input-label"}>{each.title}</span>)}

                <img
                    src={draggable}
                    className="draggable-icon"
                    {...dragHandleProps}
                />
            </th>
            <td colSpan={3} className="fieldset-td">
                {modify ? (
                    <DrawerTriger className={data.isRequired ? "border-red" : ""}>
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5"
                             stroke="currentColor"
                             className="w-4 h-4 inline mr-[5px]">
                            <path strokeLinecap="round" strokeLinejoin="round"
                                  d="M18 7.5v3m0 0v3m0-3h3m-3 0h-3m-2.25-4.125a3.375 3.375 0 1 1-6.75 0 3.375 3.375 0 0 1 6.75 0ZM3 19.235v-.11a6.375 6.375 0 0 1 12.75 0v.109A12.318 12.318 0 0 1 9.374 21c-2.331 0-4.512-.645-6.374-1.766Z"/>
                        </svg>
                        선택
                    </DrawerTriger>
                ) : (
                    <FieldFormatDisplay type="USER" />
                )}
                        <div className="inline-block relative">
                            {modify ? (
                                <SwitchBasic
                                    onCheckedChange={(checked) => {
                                        setData((prev) => ({
                                            ...prev,
                                            isRequired: checked,
                                        }));
                                    }}
                                    className={"absolute top-[-15px] left-[258px]"} defaultChecked={each.isRequired}/>
                            ):(<></>)}
                        </div>

                {modify ? (
                    <>
                        <button className="list-btn float-right hover-black ml-auto mt-[2px] bg-cancel-important" onClick={()=>setModify(false)}>취소</button>
                        <button className="list-btn float-right hover-black ml-auto mt-[2px] bg-save-important" onClick={save}>저장 </button>
                    </>

                ) : (
                    <>
                        <button className="list-btn float-right hover-black ml-auto mt-[2px] bg-delete-important" onClick={deleteItem}>삭제</button>
                        <button className="list-btn float-right hover-black ml-auto mt-[2px] " onClick={update}>수정</button>
                    </>
                )}
            </td>
        </>
    );
}

export default FieldUser;